import * as React from 'react';

const ElectronicsBadgeFilled16 = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M9.95 1.426c.236.237.557.37.892.37h1.92c.698 0 1.263.566 1.263 1.263v1.92c0 .335.134.656.37.893l1.235 1.234a1.264 1.264 0 0 1 0 1.788l-1.234 1.234c-.237.237-.37.558-.37.894v1.567c0 .698-.566 1.263-1.263 1.263h-1.57c-.334 0-.655.133-.892.37L8.893 15.63a1.262 1.262 0 0 1-1.786 0L5.7 14.222a1.262 1.262 0 0 0-.892-.37h-1.57a1.263 1.263 0 0 1-1.262-1.263v-1.567c0-.336-.134-.657-.37-.894L.37 8.894a1.264 1.264 0 0 1 0-1.788l1.234-1.234c.237-.237.37-.558.37-.894V3.06c0-.697.566-1.263 1.263-1.263h1.921c.335 0 .656-.133.893-.37L7.107.37a1.262 1.262 0 0 1 1.786 0l1.056 1.056Zm-1.325 2.7h-1.25v3.25h1.25v-3.25Zm.955 2.1a2.375 2.375 0 1 1-3.16 0l-.752-1.002a3.625 3.625 0 1 0 4.663 0L9.58 6.226Z"
  }
));
ElectronicsBadgeFilled16.Size = 16;
ElectronicsBadgeFilled16.Title = "ElectronicsBadgeFilled";

export { ElectronicsBadgeFilled16 as default };
